import React from "react";
import { Field } from "formik";

import {
  Input as InputElement,
} from "./styles";
import TplGroup from "../tpl-group";
import IField from "../../../../interfaces/field";

type IProps = any & IField

const InputPhone = ({
  placeholder = "Digite aqui",
  required = false,
  name,
  prefixName = "",
  title,
  type,
  ...el
}: IProps): JSX.Element | null => {
  const handleChange = (event: { target: { value: string } }): void => {
    let { value } = event.target;
    if (el.validations?.includes("email")) value = event.target.value.replace(/\s/g, "");

    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, value);
    }
  };

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      <Field
        type={type || "text"}
        name={`${prefixName}${name}`}
        required={required}
        value={el.values[name]}
        onChange={(event: any) => handleChange(event)}
        placeholder={placeholder || ""}
        as={InputElement}
        mask="(99) 99999-9999"
        maskChar=" "
      />
    </TplGroup>
  );
};

export default InputPhone;
